import { createAction, props } from '@ngrx/store';
import { ChatMessage } from './chat.types';
import { FileMetaData } from '../../../services/file/file.service';

export const ChatFeature = 'chat';

// UI
export const openChat = createAction(`${ChatFeature}:open`);
export const closeChat = createAction(`${ChatFeature}:close`);
export const toggleChat = createAction(`${ChatFeature}:toggle`);

// Messages
export const loadMessages = createAction(
  `${ChatFeature}:load-messages`,
  props<{ organisationID: string }>(),
);
export const loadMessagesSuccess = createAction(
  `${ChatFeature}:load-messages-success`,
  props<{ messages: ChatMessage[] }>(),
);
export const loadMessagesFailure = createAction(
  `${ChatFeature}:load-messages-failure`,
  props<{ error: string }>(),
);

export const addNewMessage = createAction(
  `${ChatFeature}:add-new-message`,
  props<{ message: ChatMessage }>(),
);
export const sendMessage = createAction(
  `${ChatFeature}:send-message`,
  props<{ organisationID: string; content: string; files?: FileMetaData[] }>(),
);

export const sendMessageRequest = createAction(
  `${ChatFeature}:send-message-request`,
  props<{ body: any }>(),
);


export const sendMessageSuccess = createAction(
  `${ChatFeature}:send-message-success`,
);
export const sendMessageFailure = createAction(
  `${ChatFeature}:send-message-failure`,
  props<{ error: string }>(),
);

export const clearMessages = createAction(`${ChatFeature}:clear-messages`);
